import { cn } from '#app/utils/misc.tsx'
import { CarruselLogosAlianzas } from './carrusel-logos-alianzas.tsx'
import { ContactoAliadosForm } from './contacto-aliados-form.tsx'
import { Icon } from './ui/icon.tsx'

interface AlianzasSectionProps {
	className?: string
	formAction?: string
}

export function AlianzasSection({
	className,
	formAction,
}: AlianzasSectionProps) {
	return (
		<section
			className={cn(
				'box-border flex w-full flex-col items-center justify-start gap-2.5 px-0 py-8 md:py-[100px]',
				className,
			)}
		>
			{/* Container */}
			<div className="mx-auto flex w-full max-w-[300px] flex-col items-center justify-start gap-[50px] md:max-w-[1200px] md:gap-[100px]">
				{/* Partnership Section Header */}
				<div className="flex flex-col items-center justify-start gap-8 text-center text-white">
					{/* Título */}
					<h2 className="font-parkinsans text-2xl leading-8 font-medium md:max-w-[690px] md:text-[48px] md:leading-[64px]">
						<span className="font-normal md:font-normal">Alianzas con </span>
						<span className="font-medium">valor</span>
					</h2>

					{/* Descripción */}
					<div className="font-inter max-w-[280px] text-base leading-[26px] font-normal md:max-w-[800px] md:text-lg md:leading-9">
						<p className="mb-0">
							Construimos alianzas con empresas y organizaciones que comparten
							nuestra visión:{' '}
						</p>
						<p className="m-0 font-medium">
							Generar impacto real, positivo y sostenible en cada proyecto que
							emprendemos.
						</p>
					</div>
				</div>

				{/* Carrusel de Logos */}
				<div
					className="w-full overflow-hidden"
					style={{
						width: '100vw',
						marginLeft: 'calc(-50vw + 50%)',
						marginRight: 'calc(-50vw + 50%)',
					}}
				>
					<CarruselLogosAlianzas />
				</div>

				{/* Partnership Details */}
				<div className="flex w-full items-center justify-center">
					<div className="flex w-full max-w-[300px] flex-col items-center justify-start gap-16 md:max-w-[1200px] md:flex-row md:items-start md:justify-center md:gap-[100px]">
						{/* Left Column - Description */}
						<div className="flex flex-1 flex-col items-center justify-start gap-4 text-center text-white md:text-left">
							<h3 className="font-parkinsans w-full text-2xl leading-8 font-medium md:text-[40px] md:leading-[56px]">
								Más que una decisión comercial
							</h3>
							<p className="font-inter w-full text-base leading-[26px] font-normal md:text-lg md:leading-9">
								Porque estamos convencidos de que el verdadero valor está en lo
								que logramos juntos.
							</p>
						</div>

						{/* Right Column - Benefits List */}
						<div className="flex flex-1 flex-col items-start justify-start gap-16">
							<div className="flex w-full flex-col items-start justify-start gap-4">
								{/* Benefit 1 */}
								<div className="flex w-full items-center justify-start gap-4 text-white">
									<div className="flex-shrink-0">
										<Icon
											name="circle-check"
											size="lg"
											className="text-[25px]"
										/>
									</div>
									<p className="font-inter text-[16px] leading-[32px] font-medium">
										Potenciamos capacidades y multiplicamos el valor.
									</p>
								</div>

								{/* Benefit 2 */}
								<div className="flex w-full items-center justify-start gap-4 text-white">
									<div className="flex-shrink-0">
										<Icon
											name="circle-check"
											size="lg"
											className="text-[25px]"
										/>
									</div>
									<p className="font-inter text-[16px] leading-[32px] font-medium">
										Crecemos como comunidad y con propósito.
									</p>
								</div>

								{/* Benefit 3 */}
								<div className="flex w-full items-start justify-start gap-4 text-white">
									<div className="flex-shrink-0 pt-1">
										<Icon
											name="circle-check"
											size="lg"
											className="text-[25px]"
										/>
									</div>
									<p className="font-inter text-[16px] leading-[32px] font-medium">
										Modelo de trabajo donde el compromiso, la transparencia y la
										búsqueda de un bien mayor son prioridad.
									</p>
								</div>

								{/* Benefit 4 */}
								<div className="flex w-full items-start justify-start gap-4 text-white">
									<div className="flex-shrink-0 pt-1">
										<Icon
											name="circle-check"
											size="lg"
											className="text-[25px]"
										/>
									</div>
									<p className="font-inter text-[16px] leading-[32px] font-medium">
										Construimos redes que no solo conectan negocios, sino
										también personas, valores e intenciones.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Contact Section */}
				<div className="flex w-full max-w-[300px] rounded-[16px] bg-white md:max-w-[1200px]">
					<div className="flex flex-1 items-center">
						<div className="flex w-full flex-col items-center justify-start gap-6 p-6 md:flex-row md:items-center md:justify-start md:gap-8 md:px-16 md:py-8">
							{/* Contact Details */}
							<div className="flex flex-1 flex-col items-start justify-center gap-4">
								<div className="flex w-full items-center justify-center">
									<h3 className="font-parkinsans text-2xl leading-8 font-medium text-blue-800 md:rotate-[0.462deg] md:transform md:text-[32px] md:leading-[45px]">
										¿Querés ser parte de nuestra red de aliados estratégicos?
									</h3>
								</div>
								<div className="flex w-full items-center justify-center">
									<p className="font-inter text-base leading-[26px] font-normal text-neutral-600 md:rotate-[0.462deg] md:transform">
										Escribinos y descubrí cómo podemos trabajar juntos para
										generar impacto y valor compartido.
									</p>
								</div>
							</div>

							{/* Contact Form */}
							<div className="flex w-full flex-col items-end justify-center gap-6 md:flex-1">
								<ContactoAliadosForm action={formAction} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default AlianzasSection
